module.exports = "https://cdn.ticketswap.com/_next/static/images/mobile-screen-aaf11fddc5fa3b476a2d4bc93ed86529.jpg";